import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import NewLoadSchedule from './NewLoadSchedule';
import NewUnloadSchedule from './NewUnloadSchedule';
import ScheduleTypeChoice from './ScheduleTypeChoice';
import DriverSelection from './components/DriverSelection';
import Calendar from './components/Calendar';

// styles
import './styles.css';

export default class NewSchedule extends Component {
  render() {
    const { match } = this.props;
    return (
      <div className="NewSchedule">
        <Switch>
          <Route path={`${match.url}/carga`} component={NewLoadSchedule} />
          <Route path={`${match.url}/descarga`} component={NewUnloadSchedule} />
          <Route path={`${match.url}/motoristas`} component={DriverSelection} />
          <Route path={`${match.url}/calendario`} component={Calendar} />
          <Route exact path={`${match.url}`} component={ScheduleTypeChoice} />
        </Switch>
      </div>
    );
  }
}
